(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-row"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.init === '1') return;
      root.dataset.init = '1';
      var nav = root.querySelector('[data-tabs-nav]');
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));
      if (!panels.length) return;
      var showTabs = parseInt(root.dataset.showTabs, 10) || 8;
      // Always shuffle, then show only `showTabs` tabs — a random subset of the full set each load.
      for (var i = panels.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = panels[i]; panels[i] = panels[j]; panels[j] = tmp;
      }
      var chosen = panels.slice(0, showTabs);
      panels.forEach(function (p) { p.hidden = true; });
      nav.innerHTML = '';
      function activate(panel, btn) {
        chosen.forEach(function (q) { q.hidden = true; });
        nav.querySelectorAll('.hd-cattabs__tab').forEach(function (x) { x.classList.remove('is-active'); });
        panel.hidden = false;
        btn.classList.add('is-active');
        var tr = panel.querySelector('[data-track]');
        if (tr) tr.scrollLeft = 0;
      }
      chosen.forEach(function (p, idx) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'hd-cattabs__tab' + (idx === 0 ? ' is-active' : '');
        b.textContent = p.getAttribute('data-title');
        b.addEventListener('click', function () { activate(p, b); });
        nav.appendChild(b);
        if (idx === 0) p.hidden = false;
      });
      function activeTrack() {
        for (var k = 0; k < chosen.length; k++) { if (!chosen[k].hidden) return chosen[k].querySelector('[data-track]'); }
        return null;
      }
      function nudge(dir) { var tr = activeTrack(); if (tr) tr.scrollBy({ left: dir * tr.clientWidth * 0.8, behavior: 'smooth' }); }
      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      if (prev) prev.addEventListener('click', function () { nudge(-1); });
      if (next) next.addEventListener('click', function () { nudge(1); });
    }
    function initAll() { document.querySelectorAll('[data-cattabs]').forEach(init); }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-cattabs]');
      if (el) { el.dataset.init = ''; init(el); }
    });
    document.addEventListener('click', function (e) {
      document.querySelectorAll('.hd-catmenu[open]').forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(root) {
      if (!root || root.dataset.heroInit === '1') return;
      root.dataset.heroInit = '1';
      var slides = Array.prototype.slice.call(root.querySelectorAll('.custom-hero__slide'));
      if (slides.length <= 1) return;
      var bar = root.querySelector('[data-hero-progress]');
      var speed = parseInt(root.dataset.speed, 10) || 6000;
      var autoplay = root.dataset.autoplay === 'true';
      var i = 0, timer = null;

      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
        restartProgress();
      }
      function next() { show(i + 1); }
      function prev() { show(i - 1); }
      function restartProgress() {
        if (!bar || !autoplay) return;
        bar.style.transition = 'none';
        bar.style.width = '0%';
        void bar.offsetWidth;
        bar.style.transition = 'width ' + speed + 'ms linear';
        bar.style.width = '100%';
      }
      function start() { if (autoplay) { stop(); timer = setInterval(next, speed); restartProgress(); } }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      var nextBtn = root.querySelector('[data-hero-next]');
      var prevBtn = root.querySelector('[data-hero-prev]');
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      start();
    }
    function initAll() {
      document.querySelectorAll('[data-hero-slider]').forEach(initHero);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-hero-slider]');
      if (el) { el.dataset.heroInit = ''; initHero(el); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-mega-menu"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function wire(el) {
      if (el.dataset.wired === '1') return;
      el.dataset.wired = '1';
      document.addEventListener('click', function (e) {
        if (el.open && !el.contains(e.target)) el.open = false;
      });
      el.addEventListener('keydown', function (e) { if (e.key === 'Escape') el.open = false; });
    }
    function initAll() { document.querySelectorAll('[data-hd-mega]').forEach(wire); }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-monthly-special"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function shuffleSpecial(row) {
      if (!row || row.dataset.shuffled === '1') return;
      row.dataset.shuffled = '1';
      var show = parseInt(row.dataset.show, 10) || 5;
      var items = Array.prototype.slice.call(row.querySelectorAll('[data-shuffle-item]'));
      for (var i = items.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = items[i]; items[i] = items[j]; items[j] = tmp;
      }
      items.forEach(function (el, idx) {
        if (idx < show) { row.appendChild(el); el.style.display = ''; }
        else { el.style.display = 'none'; }
      });
    }
    function initAll() { document.querySelectorAll('[data-special-shuffle]').forEach(shuffleSpecial); }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-special-shuffle]');
      if (el) { el.dataset.shuffled = ''; shuffleSpecial(el); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-vendor-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Paced logo loader — the brand image server rate-limits bursts, so we load
    // logos a couple at a time (with one retry) instead of all at once.
    var LQ = { q: [], active: 0, max: 6, gap: 80 };
    function queueLogo(img, url, onFail) {
      if (!img || !url) return;
      LQ.q.push({ img: img, url: url, fail: onFail });
      pumpLQ();
    }
    function pumpLQ() {
      while (LQ.active < LQ.max && LQ.q.length) {
        LQ.active++;
        (function (it) {
          // Preload in a detached image; only reveal on the page once confirmed,
          // so a throttled/failed request never shows a broken-image icon.
          var probe = new Image();
          probe.referrerPolicy = 'no-referrer';
          var tried = 0;
          probe.onload = function () { it.img.src = probe.src; LQ.active--; setTimeout(pumpLQ, LQ.gap); };
          probe.onerror = function () {
            tried++;
            if (tried < 2) { setTimeout(function () { probe.src = it.url.split('?')[0] + '?r=' + Date.now(); }, 900); }
            else { if (it.fail) { it.fail(it.img); } LQ.active--; setTimeout(pumpLQ, LQ.gap); }
          };
          probe.src = it.url;
        })(LQ.q.shift());
      }
    }
    function init(root) {
      if (!root || root.dataset.init === '1') return;
      root.dataset.init = '1';
      var nav = root.querySelector('[data-tabs-nav]');
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));
      if (!panels.length || !nav) return;
      var auto = root.dataset.auto === '1';
      var showTabs = parseInt(root.dataset.showTabs, 10) || 8;
      if (auto) {
        for (var i = panels.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = panels[i]; panels[i] = panels[j]; panels[j] = t; }
      }
      var chosen = auto ? panels.slice(0, showTabs) : panels;
      panels.forEach(function (p) { p.hidden = true; });
      nav.innerHTML = '';
      function activate(panel, btn) {
        chosen.forEach(function (q) { q.hidden = true; });
        nav.querySelectorAll('.hd-vendors__tab').forEach(function (x) { x.classList.remove('is-active'); });
        panel.hidden = false;
        btn.classList.add('is-active');
        var tr = panel.querySelector('[data-track]');
        if (tr) tr.scrollLeft = 0;
      }
      chosen.forEach(function (p, idx) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'hd-vendors__tab' + (idx === 0 ? ' is-active' : '');
        var title = p.getAttribute('data-title');
        var logo = p.getAttribute('data-logo');
        if (logo) {
          var img = document.createElement('img');
          img.className = 'hd-vendors__tab-logo';
          img.alt = '';
          img.referrerPolicy = 'no-referrer';
          b.appendChild(img);
          queueLogo(img, logo, function (x) { x.remove(); });
        }
        var name = document.createElement('span');
        name.className = 'hd-vendors__tab-name';
        name.textContent = title;
        b.appendChild(name);
        b.addEventListener('click', function () { activate(p, b); });
        nav.appendChild(b);
        if (idx === 0) p.hidden = false;
      });
      function activeTrack() {
        for (var k = 0; k < chosen.length; k++) { if (!chosen[k].hidden) return chosen[k].querySelector('[data-track]'); }
        return null;
      }
      function nudge(dir) { var tr = activeTrack(); if (tr) tr.scrollBy({ left: dir * tr.clientWidth * 0.8, behavior: 'smooth' }); }
      var prev = root.querySelector('[data-prev]');
      var next = root.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { nudge(-1); });
      if (next) next.addEventListener('click', function () { nudge(1); });

      // Paced-load the "See all brands" dropdown logos the first time it opens.
      // The dropdown is a SIBLING of [data-vendor-tabs] (both live in the section's
      // page-width), so scope the lookup there, not to root, or the logos are never found.
      var scope = root.closest('.page-width') || root.parentElement || document;
      var menu = scope.querySelector('.hd-catmenu');
      if (menu) {
        var started = false;
        var loadDrop = function () {
          if (started) { return; } started = true;
          scope.querySelectorAll('.hd-catmenu__logo[data-src]').forEach(function (im) {
            queueLogo(im, im.getAttribute('data-src'), function (x) { x.style.display = 'none'; });
          });
        };
        menu.addEventListener('toggle', function () { if (menu.open) { loadDrop(); } });
      }
    }
    function initAll() { document.querySelectorAll('[data-vendor-tabs]').forEach(init); }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('click', function (e) {
      document.querySelectorAll('.hd-catmenu[open]').forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
    });
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-vendor-tabs]');
      if (el) { el.dataset.init = ''; init(el); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
